import { useTranslation } from "react-i18next";

type Props = {
  value?: string;
  onChange: (text: string) => void;
  maxLength?: number | null;
  placeholder?: string;
};

export default function TextAnswer({
  value = "",
  onChange,
  maxLength = 100,
  placeholder,
}: Props) {
  const { t } = useTranslation();
  const limit = maxLength || 100;

  return (
    <div className="w-full">
      <div className="border border-white/10 focus-within:border-orange-100 rounded-xl overflow-hidden transition-300">
        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value.slice(0, limit))}
          placeholder={placeholder || t("survey_text_placeholder") || "Javobingizni kiriting"}
          maxLength={limit}
          rows={5}
          className="w-full bg-transparent py-3 px-4 text-sm text-white placeholder:text-gray-1 leading-140 font-medium outline-none resize-none"
        />
        <div className="flex justify-end px-4 pb-2">
          <span className="text-xs text-gray-1">
            {value.length}/{limit}
          </span>
        </div>
      </div>
    </div>
  );
}
